if (!customElements.get('ugc-content-section')) {
  class UGCContentSection extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
    }

    connectedCallback() {
      this.initPlayButtons();
      this.initSwiper();
    }

    initPlayButtons() {
      const playBtns = this.querySelectorAll('[data-play-btn]');

      playBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          const wrapper = btn.closest('.ugc-video-wrapper');
          const video = wrapper.querySelector('video');
          const poster = wrapper.querySelector('.ugc-poster');

          if (video) {
            video.muted = false;
            video.controls = true;
            const playPromise = video.play();

            if (playPromise !== undefined) {
              playPromise.then(() => {
                btn.classList.add('hidden');
                if (poster) poster.classList.add('hidden');
              }).catch(() => {
                // Play failed, keep button visible
              });
            }

            // Show button again when video ends
            video.addEventListener('ended', () => {
              btn.classList.remove('hidden');
              if (poster) poster.classList.remove('hidden');
              video.muted = true;
              video.controls = false;
            });
          }
        });
      });
    }

    initSwiper() {
      const swiperEl = this.querySelector('.ugc-swiper');
      if (!swiperEl) return;

      this.swiper = new Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 16,
        loop: false,
        grabCursor: true,
        slideToClickedSlide: false,
        breakpoints: {
          320: {
            slidesPerView: 1.2,
            spaceBetween: 16
          },
          750: {
            slidesPerView: 1.2,
            spaceBetween: 16
          }
        }
      });
    }

    disconnectedCallback() {
      if (this.swiper) {
        this.swiper.destroy();
      }
    }
  }

  customElements.define('ugc-content-section', UGCContentSection);
}
